<template>
  <MakerCartGuideLayout
    pageTitle="Material Management"
    heroImage="/images/maker-cart-guide/frame-10000064031.png"
    previousUrl="/makercart/guide/10"
    :is-last-step="true"
    next-url="/makercart/catalog"
  >
    <div class="x-section">
      <div class="x-image-container-flat">
        <img
          src="/images/maker-cart-guide/group-1000003794.svg"
          height="180px"
          alt="Tinker to Discover"
        />
      </div>
      <div class="x-section-content">
        <h2 class="x-section-title">Fixed Quantity</h2>
        <div class="x-section-body">
          <p>
            Fixed quantity is a method where students can take a fixed amount of
            items from the cart. The amount decided is up to the facilitator's
            discretion. In this scenario, the teachers have to be gatekeepers of
            the materials to prevent hoarding. Students have to plan which item
            is of priority to get for them to complete the project.
          </p>
        </div>
      </div>
    </div>

    <div class="x-section">
      <div class="x-image-container-flat">
        <img
          src="/images/maker-cart-guide/story-1.svg"
          height="180px"
          alt="Tinker to Discover"
        />
      </div>
      <div class="x-section-content">
        <h2 class="x-section-title">Material Costing</h2>
        <div class="x-section-body">
          <p>
            Material costing is a method for students to plan the materials they
            want to purchase within the given budget and take the materials
            according to what they've written on the budget sheet. Facilitators
            may do a spot check to see if the students carry this out.
          </p>
          <p>
            Facilitators would have to place a price tag on the materials. The
            price tag may be in the form of a monetary value ($1.00) or a
            representative value (Stars, Points, etc). We've provided a template
            of the budget sheet below as a printable resource.
          </p>
        </div>
        <ActionButton variant="primary" class="x-budget-download-btn">
          Download Budget Sheet
        </ActionButton>
      </div>
    </div>
  </MakerCartGuideLayout>
</template>

<script setup>
import MakerCartGuideLayout from "@/components/maker-cart/MakerCartGuideLayout.vue";
import ActionButton from "@/components/common/ActionButton.vue";
</script>

<style scoped>
.congrats-modal__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.congrats-modal__image {
  width: 100%;
  max-width: 310px;
  height: auto;
  margin: -16px 0 16px 0;
}

.congrats-modal__title {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: var(--fs-large);
  line-height: 28px;
  color: #00925e;
  margin: 0 0 16px 0;
}

.congrats-modal__description {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: var(--fs-small);
  line-height: 20px;
  letter-spacing: 0.035px;
  color: #3b4648;
  margin: 0;
}

.congrats-modal__actions {
  display: flex;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
}

.x-budget-download-btn {
  width: fit-content;
  margin-top: 16px;
}

.congrats-btn-outline,
.congrats-btn-primary {
  flex: 1;
  height: 40px;
  border-radius: 8px;
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-small);
  line-height: 20px;
  letter-spacing: 0.014px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.congrats-btn-outline {
  border: 1px solid var(--primary-blue);
  background: transparent;
  color: var(--primary-blue);
}

.congrats-btn-outline:hover {
  background: #f2f3fb;
}

.congrats-btn-primary {
  border: 1px solid var(--primary-blue);
  background: var(--primary-blue);
  color: #ffffff;
}

.congrats-btn-primary:hover {
  background: #012a47;
}

@media (max-width: 768px) {
  :deep(.x-section img) {
    height: 100px;
    width: 100px;
  }
}
</style>
